import React, { useEffect, useState } from 'react'
import { formatDistanceToNow } from "date-fns";
import { useParams, useNavigate, NavLink, useLocation } from "react-router-dom";
import api from "@api";
import "./LeagueProfileV2.css"
import Facebook from '../../../../icons/facebook.png';
import Instagram from '../../../../icons/instagram.png';
import Youtube from '../../../../icons/youtube.png';
import Twitter from '../../../../icons/twitter.png';
import { FaUser, FaPhoneAlt, FaEnvelope, FaGlobe, FaMapMarkerAlt } from "react-icons/fa";
import ClaimLeagueModal from "../../Components/ClaimModal/ClaimLeagueModal";
import { useAuth } from "../../../../context/AuthContext";
import DirectoryAuthMenu from "../../Auth/DirectoryAuthMenu";
import DirectoryFooter from "../../Components/Footer/DirectoryFooter.jsx";
import { Helmet } from "react-helmet-async";
import { getProgramTypeLabel } from "../../../../utils/programTypes";









function LeagueProfileV2() {
  const navigate = useNavigate();
  const location = useLocation();
  const preloadedLeagueProfile = location.state?.preloadedLeagueProfile;
  const [league, setLeague] = useState(preloadedLeagueProfile || null);
  const [loading, setLoading] = useState(!preloadedLeagueProfile);
  const [showFullAbout, setShowFullAbout] = useState(false);
  const [showAllPrograms, setShowAllPrograms] = useState(true);
  const [selectedGalleryImage, setSelectedGalleryImage] = useState(null);
  const [selectedVenueName, setSelectedVenueName] = useState("");
  const [pillModal, setPillModal] = useState(null);
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [activeProgramFilter, setActiveProgramFilter] = useState("all");
  const [publicUser, setPublicUser] = useState(null);
  const [expandedProgramDescriptionId, setExpandedProgramDescriptionId] = useState(null);
  const [expandedProgramNotesId, setExpandedProgramNotesId] = useState(null);
  const { leagueNameAndId } = useParams();
  const directoryLeagueId = leagueNameAndId?.split("-").pop();
  const [showClaimModal, setShowClaimModal] = useState(false);
  const { isAuthenticated, checkAuth } = useAuth();
  const [activeSportFilter, setActiveSportFilter] = useState("all");

  const fetchLeague = async () => {
    try {
      if (!directoryLeagueId) {
        setLoading(false);
        return;
      }
      const res = await api.get(`/api/directory/leagues/${directoryLeagueId}`);
      setLeague(res.data);
    } catch (err) {
      console.error("Failed to fetch league", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (preloadedLeagueProfile) return;
    fetchLeague();
  }, [directoryLeagueId, preloadedLeagueProfile]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, [directoryLeagueId]);


  useEffect(() => {
    const loadPublicAuth = async () => {
      try {
        const { data } = await api.get("/api/auth/public", { withCredentials: true });
        setPublicUser(data?.user || null);
      } catch (error) {
        setPublicUser(null);
      }
    };

    loadPublicAuth();
  }, []);


  const truncateWords = (text, wordLimit = 45) => {
    if (!text) return "";
    const words = text.trim().split(/\s+/);
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(" ");
  };

  const {
    name,
    city,
    state,
    is_verified,
    website_url,
    register_label,
    register_url,
    programs = [],
    description,
    contact_name,
    email,
    phone_number,
    instagram_url,
    facebook_url,
    twitter_url,
    youtube_url,
    directory_logo,
    venues = [],
  } = league || {};
  const hasContactInfo = Boolean(contact_name || email || phone_number);
  const hasSocialLinks = Boolean(instagram_url || facebook_url || twitter_url || youtube_url);
  const listingVenues = Array.isArray(venues) ? venues : [];

  const programVenues = programs.flatMap((program) =>
    Array.isArray(program.venues) ? program.venues : []
  );

  const allVenues = [...listingVenues, ...programVenues];

  const uniqueVenues = allVenues.filter(
    (venue, index, self) =>
      venue?.name &&
      index === self.findIndex((v) => v?.name === venue?.name)
  );

  const activeVenue =
    uniqueVenues.find((venue) => venue.name === selectedVenueName) || uniqueVenues[0];

  const getEmbedMapSrc = (venue) => {
    const rawUrl = venue?.map_url?.trim();

    const fallbackMapQuery = [
      venue?.name,
      city,
      state,
    ].filter(Boolean).join(", ");

    if (rawUrl) {
      try {
        const parsed = new URL(rawUrl);

        if (parsed.hostname.includes("google.com")) {
          const pathParts = parsed.pathname.split("/place/");
          if (pathParts[1]) {
            const placeNameFromUrl = decodeURIComponent(pathParts[1].split("/")[0]).replace(/\+/g, " ");

            const betterQuery = [
              placeNameFromUrl,
              city,
              state,
            ].filter(Boolean).join(", ");

            return `https://www.google.com/maps/embed/v1/place?key=${import.meta.env.VITE_GOOGLE_MAPS_EMBED_API_KEY}&q=${encodeURIComponent(betterQuery)}`;
          }
        }
      } catch (error) {
        console.error("Invalid map URL:", rawUrl);
      }
    }

    return fallbackMapQuery
      ? `https://www.google.com/maps/embed/v1/place?key=${import.meta.env.VITE_GOOGLE_MAPS_EMBED_API_KEY}&q=${encodeURIComponent(fallbackMapQuery)}`
      : "";
  };

  const mapEmbedSrc = getEmbedMapSrc(activeVenue);

  useEffect(() => {
    if (!selectedVenueName && uniqueVenues.length > 0) {
      setSelectedVenueName(uniqueVenues[0].name);
    }
  }, [selectedVenueName, uniqueVenues]);
  const formatLabel = (value) => {
    if (!value) return "";

    const agePlusMatch = value.match(/^(\d+)(_|\s)?plus$/i);
    if (agePlusMatch) {
      return `${agePlusMatch[1]}+`;
    }

    return value
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const sortedPrograms = [...programs].sort((a, b) => {
    const orderA =
      a.display_order !== null && a.display_order !== undefined
        ? Number(a.display_order)
        : 9999;

    const orderB =
      b.display_order !== null && b.display_order !== undefined
        ? Number(b.display_order)
        : 9999;

    return orderA - orderB;
  });
  const sportFilteredPrograms = sortedPrograms.filter((program) => {
    if (activeSportFilter === "all") return true;
    return (program.sport || "").toLowerCase() === activeSportFilter;
  });
  const filteredPrograms = sportFilteredPrograms.filter((program) => {
    if (activeProgramFilter === "all") return true;
    return (program.program_type || "").toLowerCase() === activeProgramFilter;
  });
  const sportFilterTabs = [
    "all",
    ...new Set(
      programs
        .map((program) => program.sport)
        .filter(Boolean)
        .map((sport) => sport.toLowerCase())
    ),
  ];
  useEffect(() => {
    if (!filteredPrograms.length) {
      setSelectedProgram(null);
      return;
    }

    const selectedStillExists = filteredPrograms.some(
      (program) => program.id === selectedProgram?.id
    );

    if (!selectedStillExists) {
      setSelectedProgram(filteredPrograms[0]);
    }
  }, [filteredPrograms, selectedProgram]);

  const groupedPrograms = Object.entries(
    filteredPrograms.reduce((acc, program) => {
      const sportKey = formatLabel(program.sport || "Other");
      if (!acc[sportKey]) acc[sportKey] = [];
      acc[sportKey].push(program);
      return acc;
    }, {})
  );

  // const visibleGroupedPrograms = showAllPrograms
  //   ? groupedPrograms
  //   : groupedPrograms.slice(0, 1);
  const visibleGroupedPrograms = groupedPrograms;

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!league) return null;


  const normalizeGenderArray = (gender) => {
    if (Array.isArray(gender)) return gender;

    if (typeof gender === "string") {
      const trimmed = gender.trim();

      if (trimmed.startsWith("{") && trimmed.endsWith("}")) {
        return trimmed
          .slice(1, -1)
          .split(",")
          .map((g) => g.trim().replace(/^"|"$/g, ""))
          .filter(Boolean);
      }

      return trimmed ? [trimmed] : [];
    }

    return [];
  };

  const getDivisionLabels = (program) => {
    const genders = normalizeGenderArray(program.gender);

    if (!genders.length) return [];

    const minAge = Number(program.min_age);
    const maxAge = Number(program.max_age);

    const hasMinAge = Number.isFinite(minAge) && minAge > 0;
    const hasMaxAge = Number.isFinite(maxAge) && maxAge > 0;

    const isYouthOnly = hasMaxAge && maxAge < 18;
    const isAdultOnly = hasMinAge && minAge >= 18;

    return [...new Set(
      genders.map((gender) => {
        if (gender === "male") {
          if (isYouthOnly) return "Boys";
          if (isAdultOnly) return "Men";
          return "Male";
        }

        if (gender === "female") {
          if (isYouthOnly) return "Girls";
          if (isAdultOnly) return "Women";
          return "Female";
        }

        if (gender === "coed") {
          return "Coed";
        }

        return formatLabel(gender);
      })
    )];
  };

  const getProgramAgeLabel = (program) => {
    const minAge = Number(program.min_age);
    const maxAge = Number(program.max_age);

    const hasMinAge = Number.isFinite(minAge) && minAge > 0;
    const hasMaxAge = Number.isFinite(maxAge) && maxAge > 0;

    if (hasMinAge && hasMaxAge) {
      return `Ages ${minAge}–${maxAge}`;
    }

    if (hasMinAge) {
      return `Ages ${minAge}+`;
    }

    return "All ages";
  };

  const uniqueSports = [
    ...new Set(programs.map((p) => p.sport).filter(Boolean))
  ].map(formatLabel);

  const hasYouthPrograms = programs.some((p) => {
    const maxAge = Number(p.max_age);
    return Number.isFinite(maxAge) && maxAge > 0 && maxAge < 18;
  });

  const hasAdultPrograms = programs.some((p) => {
    const minAge = Number(p.min_age);
    return Number.isFinite(minAge) && minAge >= 18;
  });

  const genderedPrograms = programs.filter((p) => {
    const genders = normalizeGenderArray(p.gender);
    return genders.length > 0;
  });

  const isOrgYouthOnly =
    genderedPrograms.length > 0 &&
    genderedPrograms.every((p) => {
      const maxAge = Number(p.max_age);
      return Number.isFinite(maxAge) && maxAge > 0 && maxAge < 18;
    });

  const isOrgAdultOnly =
    genderedPrograms.length > 0 &&
    genderedPrograms.every((p) => {
      const minAge = Number(p.min_age);
      return Number.isFinite(minAge) && minAge >= 18;
    });

  const uniqueAudiences = [
    ...new Set(
      programs.flatMap((p) =>
        normalizeGenderArray(p.gender).map((gender) => {
          if (gender === "male") {
            if (isOrgYouthOnly) return "Boys";
            if (isOrgAdultOnly) return "Men";
            return "Male";
          }

          if (gender === "female") {
            if (isOrgYouthOnly) return "Girls";
            if (isOrgAdultOnly) return "Women";
            return "Female";
          }

          if (gender === "coed") {
            return "Coed";
          }

          return formatLabel(gender);
        })
      ).filter(Boolean)
    )
  ];

  const uniqueProgramTypes = [
    ...new Set(programs.map((p) => p.program_type).filter(Boolean))
  ].map(getProgramTypeLabel);

  const uniqueStyles = [
    ...new Set(programs.map((p) => p.competition_level).filter(Boolean))
  ].map(formatLabel);

  const sportLabel =
    uniqueSports.length > 1
      ? `${uniqueSports[0]} +${uniqueSports.length - 1}`
      : uniqueSports[0] || "";

  const audienceLabel =
    uniqueAudiences.length > 1
      ? `${uniqueAudiences[0]} +${uniqueAudiences.length - 1}`
      : uniqueAudiences[0] || "";

  const programTypeLabel =
    uniqueProgramTypes.length > 1
      ? `${uniqueProgramTypes[0]} +${uniqueProgramTypes.length - 1}`
      : uniqueProgramTypes[0] || "";

  const styleLabel =
    uniqueStyles.length > 1
      ? `${uniqueStyles[0]} +${uniqueStyles.length - 1}`
      : uniqueStyles[0] || "";

  const cityValues = [
    city,
    ...(Array.isArray(league.locations) ? league.locations : []),
  ].filter(Boolean);

  const uniqueCities = [...new Set(cityValues)];

  const locationsLabel =
    uniqueCities.length > 1
      ? `${uniqueCities[0]} +${uniqueCities.length - 1}`
      : uniqueCities[0] || state || "";


  const sportFullList = uniqueSports.join(", ");
  const audienceFullList = uniqueAudiences.join(", ");
  const programTypeFullList = uniqueProgramTypes.join(", ");
  const styleFullList = uniqueStyles.join(", ");
  const citiesFullList = uniqueCities.join(", ");




  const normalizeUrl = (url) => {
    if (!url) return "";
    if (/^https?:\/\//i.test(url)) return url;
    return `https://${url}`;
  };

  const listedOnLabel = league.createdAt
    ? new Date(league.createdAt).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    })
    : null;

  const lastUpdatedLabel = league.listing_updated_at
    ? formatDistanceToNow(new Date(league.listing_updated_at), { addSuffix: true }).replace("about ", "")
    : null;

  const formattedViews =
    (league.view_count || 0) >= 1000000
      ? `${((league.view_count || 0) / 1000000).toFixed(1)}M`
      : (league.view_count || 0) >= 1000
        ? `${((league.view_count || 0) / 1000).toFixed(1)}K`
        : String(league.view_count || 0);

  const getProgramTitle = (program) => {
    if (!program) return "";

    if (program.title?.trim()) return program.title.trim();

    if (program.program_type) return getProgramTypeLabel(program.program_type);

    return "";
  };
  const programFilterTabs = [
    "all",
    ...new Set(
      sportFilteredPrograms
        .map((program) => program.program_type)
        .filter(Boolean)
        .map((type) => type.toLowerCase())
    ),
  ];


  const locationLabel =
    city && state ? `${city}, ${state}` : city || state || "";

  const titleSportLabel = sportLabel || "Sports";
  const titleProgramTypeLabel = programTypeLabel || "Programs";

  const pageTitle = `${name} | ${titleSportLabel} ${titleProgramTypeLabel}${locationLabel ? ` in ${locationLabel}` : ""}`;

  const truncateText = (text, maxLength = 110) => {
    if (!text) return "";
    const clean = text.replace(/\s+/g, " ").trim();
    if (clean.length <= maxLength) return clean;
    return clean.slice(0, maxLength).trim() + "...";
  };

  const aboutSnippet = truncateText(description, 110);

  const ageText = (() => {
    const ages = programs
      .flatMap((p) => [p.min_age, p.max_age])
      .filter((age) => typeof age === "number" && age > 0);

    if (!ages.length) return "";

    const min = Math.min(...ages);
    const max = Math.max(...ages);

    if (min === max) return `ages ${min}+`;
    return `ages ${min}–${max}`;
  })();

  const descriptionParts = [
    `${name}${locationLabel ? ` in ${locationLabel}` : ""}`,
    sportLabel
      ? `offers ${sportLabel.toLowerCase()} ${titleProgramTypeLabel.toLowerCase()}`
      : `offers sports programs`,
    audienceLabel ? `for ${audienceLabel.toLowerCase()}` : "",
    ageText ? `with ${ageText}` : "",
    styleLabel ? `and ${styleLabel.toLowerCase()} options` : "",
  ];

  const pageDescription = aboutSnippet || `${descriptionParts.filter(Boolean).join(" ")}.`;

  const formatTime = (time) => {
    if (!time) return "";

    const [hourRaw, minuteRaw] = time.split(":");
    const hour = Number(hourRaw);
    const minute = minuteRaw || "00";

    if (!Number.isFinite(hour)) return time;

    const suffix = hour >= 12 ? "PM" : "AM";
    const displayHour = hour % 12 || 12;

    return `${displayHour}:${minute} ${suffix}`;
  };

  const formatScheduleDays = (schedule) => {
    if (Array.isArray(schedule.days) && schedule.days.length > 0) {
      return schedule.days.map((day) => day.slice(0, 3)).join(", ");
    }

    if (schedule.day) {
      return schedule.day.slice(0, 3);
    }

    return "";
  };

  const formatScheduleLine = (schedule) => {
    const days = formatScheduleDays(schedule);

    const time =
      schedule.start_time || schedule.end_time
        ? `${formatTime(schedule.start_time) || "Start"} - ${formatTime(schedule.end_time) || "End"
        }`
        : "";

    return [days, time, schedule.label].filter(Boolean).join(" · ");
  };

  const formatDate = (date) => {
    if (!date) return "";

    return new Date(`${date}T00:00:00`).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };
  const renderProgramDetail = (program, extraClass = "") => {
    if (!program) {
      return (
        <div className={`league-profile-program-detail-card ${extraClass}`.trim()}>
          <div className="league-profile-program-empty">
            Select a program to view details.
          </div>
        </div>
      );
    }




    return (
      <div className={`league-profile-program-detail-card ${groupedPrograms.length > 1 ? "has-sport-groups" : ""} ${extraClass}`.trim()}>
        <h3 className="league-profile-program-detail-title">
          {getProgramTitle(program)}
        </h3>

        <div className="league-profile-program-detail-age">
          {[
            program?.sport ? formatLabel(program.sport) : "",
            getProgramAgeLabel(program),
            !program?.title?.trim()
              ? ""
              : (program?.program_type ? getProgramTypeLabel(program.program_type) : ""),
            program?.competition_level ? formatLabel(program.competition_level) : "",
          ]
            .filter(Boolean)
            .join(" · ")}
        </div>

        {getDivisionLabels(program).length > 0 && (
          <div className="league-profile-program-detail-row">
            <span className="league-profile-program-detail-label">Audience</span>
            <span>{getDivisionLabels(program).join(" · ")}</span>
          </div>
        )}
        {Array.isArray(program.schedule_details) &&
          program.schedule_details.length > 0 && (
            <div className="league-profile-program-detail-row">
              <span className="league-profile-program-detail-label">Schedule</span>

              <div className="league-profile-program-detail-stack">
                {program.schedule_details.map((schedule, index) => {
                  const scheduleLine = formatScheduleLine(schedule);

                  if (!scheduleLine) return null;

                  return (
                    <div key={index} className="league-profile-program-detail-subline">
                      {scheduleLine}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        {Array.isArray(program.venues) &&
          program.venues.filter((venue) => venue?.name).length > 0 && (
            <div className="league-profile-program-detail-row">
              <span className="league-profile-program-detail-label">Location</span>

              <div className="league-profile-program-detail-venues">
                {program.venues
                  .filter((venue) => venue?.name)
                  .map((venue, index) => (
                    <div key={index} className="league-profile-program-modal-venue-row">
                      {venue.map_url ? (
                        <a
                          href={normalizeUrl(venue.map_url)}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="league-profile-program-venue-link"
                        >
                          {venue.name}
                        </a>
                      ) : (
                        <span>{venue.name}</span>
                      )}
                    </div>
                  ))}
              </div>
            </div>
          )}

        {(program.contact_name || program.email || program.phone_number || program.contact_note) && (
          <div className="league-profile-program-detail-contact">
            {program.contact_name && (
              <div className="league-profile-program-detail-row">
                <span className="league-profile-program-detail-label">Contact</span>
                <span>{program.contact_name}</span>
              </div>
            )}

            {program.email && (
              <div className="league-profile-program-detail-row">
                <span className="league-profile-program-detail-label">Email</span>
                <a
                  href={`mailto:${program.email}`}
                  className="league-profile-program-venue-link"
                >
                  {program.email}
                </a>
              </div>
            )}
            {program.phone_number && (
              <div className="league-profile-program-detail-row">
                <span className="league-profile-program-detail-label">Phone</span>
                <span>{program.phone_number}</span>
              </div>
            )}

            {program.contact_note && (
              <div className="league-profile-program-detail-row">
                <span className="league-profile-program-detail-label">Note</span>
                <span>{program.contact_note}</span>
              </div>
            )}
          </div>
        )}
        {(program.price ||
          program.registration_status ||
          program.registration_deadline ||
          program.start_date ||
          program.end_date ||
          program.season ||
          program.registration_url ||
          program.notes) && (
            <div className="league-profile-program-detail-info-box">
              {program.price && (
                <div className="league-profile-program-detail-row">
                  <span className="league-profile-program-detail-label">Price</span>
                  <span>{program.price}</span>
                </div>
              )}

              {program.season && (
                <div className="league-profile-program-detail-row">
                  <span className="league-profile-program-detail-label">Season</span>
                  <span>{program.season}</span>
                </div>
              )}

              {program.registration_status && (
                <div className="league-profile-program-detail-row">
                  <span className="league-profile-program-detail-label">Registration</span>
                  <span>{program.registration_status}</span>
                </div>
              )}

              {program.registration_deadline && (
                <div className="league-profile-program-detail-row">
                  <span className="league-profile-program-detail-label">Deadline</span>
                  <span>{formatDate(program.registration_deadline)}</span>
                </div>
              )}

              {(program.start_date || program.end_date) && (
                <div className="league-profile-program-detail-row">
                  <span className="league-profile-program-detail-label">Dates</span>
                  <span>
                    {[formatDate(program.start_date), formatDate(program.end_date)]
                      .filter(Boolean)
                      .join(" - ")}
                  </span>
                </div>
              )}

              {program.registration_url && (
                <a
                  href={normalizeUrl(program.registration_url)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="league-profile-program-register-link"
                >
                  Register / Book
                </a>
              )}

              {program.notes && (
                <div className="league-profile-program-detail-note">
                  {program.notes}
                </div>
              )}
            </div>
          )}
        {program.description && (
          <div className="league-profile-program-detail-description">
            {(() => {
              const isExpanded = expandedProgramDescriptionId === program.id;
              const preview = truncateWords(program.description, 45);
              const shouldTruncate =
                program.description.trim().split(/\s+/).length > 45;

              const textToShow = isExpanded ? program.description : preview;

              return (
                <>
                  {textToShow
                    .split(/\n+/)
                    .filter(Boolean)
                    .map((paragraph, index) => (
                      <p key={index}>{paragraph.trim()}</p>
                    ))}

                  {shouldTruncate && (
                    <button
                      type="button"
                      className="league-profile-read-more-inline"
                      onClick={() =>
                        setExpandedProgramDescriptionId(isExpanded ? null : program.id)
                      }
                    >
                      {isExpanded ? "Read less" : "Read more"}
                    </button>
                  )}
                </>
              );
            })()}
          </div>
        )}
      </div>
    );
  };


  const getBrowseBackPath = () => {
    const statePath = state ? state.toLowerCase() : "";
    const countyPath = league.county
      ? league.county.toLowerCase().replace(/\s+/g, "-")
      : "";

    const hasOneSport = uniqueSports.length === 1;
    const primarySport = hasOneSport
      ? uniqueSports[0]?.toLowerCase().replace(/\s+/g, "_")
      : "";

    if (statePath && countyPath && primarySport) {
      return `/state/${statePath}/county/${countyPath}/sport/${primarySport}`;
    }

    if (statePath && countyPath) {
      return `/state/${statePath}/county/${countyPath}/sport`;
    }

    if (statePath && primarySport) {
      return `/state/${statePath}/sport/${primarySport}`;
    }

    if (statePath) {
      return `/state/${statePath}/sport`;
    }

    if (primarySport) {
      return `/sport/${primarySport}`;
    }

    return "/sport";
  };
  const browseBackLabel = (() => {
    const hasOneSport = uniqueSports.length === 1;
    const primarySport = hasOneSport ? uniqueSports[0] : "Sports";

    if (league.county && state) {
      return `Browse ${primarySport} programs in ${league.county}, ${state}`;
    }

    if (city && state) {
      return `Browse ${primarySport} programs near ${city}, ${state}`;
    }

    return `Browse ${primarySport} programs`;
  })();


  const getOrgPublicUrl = (path) => {
    const org = league?.organization;

    if (!org) return "";

    if (org.domain) {
      return `${normalizeUrl(org.domain)}${path}`;
    }

    if (org.slug) {
      return `/${org.slug}${path}`;
    }

    return "";
  };

  const scheduleUrl = getOrgPublicUrl("/schedule");
  const standingsUrl = getOrgPublicUrl("/standings");
  const orgPlan = league?.organization?.plan;
  const orgStatus = league?.organization?.subscription_status;
  console.log(league)
  const hasLeagueToolsAccess =
    ["trial", "league_tools", "branded_site", "custom_domain"].includes(orgPlan) ||
    ["trialing", "active"].includes(orgStatus);
  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
      </Helmet>
      <div className="league-profile-page">
        <div className="league-profile-container">
          <div className="league-topbar">
            <div className="league-profile-logo-stack">
              <NavLink to="/" className="directory-logo">
                <span className="directory-logo-sporting">Sporting</span>
                <span className="directory-logo-hip">Hip</span>
              </NavLink>

            </div>

            <div className="directory-auth-actions">
              <DirectoryAuthMenu />
            </div>
          </div>

          <NavLink to={getBrowseBackPath()} className="league-profile-back-link">
            <span aria-hidden="true">←</span>
            <span>{browseBackLabel}</span>
          </NavLink>
          {/* Top Hero Card Container */}
          <div className="league-profile-top-card">
            <div className="league-profile-hero">
              {/* Left Side of Top Container */}
              <div className="league-profile-hero-left">
                <div className="league-profile-hero-logo">
                  {directory_logo ? (
                    <img
                      src={directory_logo}
                      alt={`${name} logo`}
                      className="league-profile-hero-logo-image"
                    />
                  ) : (
                    "logo"
                  )}
                </div>
                <div className="league-profile-hero-info">
                  <h1 className="league-profile-hero-name">{name} {is_verified && <span className="league-profile-verified-star">★</span>}</h1>
                  <div className="league-profile-hero-location">
                    {city && state ? `${city}, ${state}` : city || state || ""}
                  </div>
                  <div className="league-profile-hero-meta">
                    {listedOnLabel && <span>Listed {listedOnLabel}</span>}
                    {listedOnLabel && (lastUpdatedLabel || formattedViews) && <span className="league-profile-meta-dot">•</span>}

                    {lastUpdatedLabel && <span>Updated {lastUpdatedLabel}</span>}
                    {lastUpdatedLabel && formattedViews && <span className="league-profile-meta-dot">•</span>}

                    <span>{formattedViews} views</span>
                  </div>
                  <div className="league-profile-hero-actions">

                    {website_url && (

                      <a
                        href={normalizeUrl(website_url)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="league-profile-hero-action-btn"
                      >           <FaGlobe
                          className="league-profile-website-icon" />
                        Visit Website
                      </a>
                    )}
                    {register_url ? (
                      <a
                        href={normalizeUrl(register_url)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="league-profile-register-btn"
                      >
                        {register_label || "Register"}
                      </a>
                    ) : (
                      <button
                        type="button"
                        className="league-profile-register-btn league-profile-register-btn-disabled"
                        disabled
                      >
                        {register_label || "Register"}
                      </button>
                    )}
                  </div>
                </div>
              </div>
              {/* Right Side of Top Container */}
              <div className="league-profile-hero-right">
                {league.claimed_user_id === publicUser?.id && (
                  <button
                    type="button"
                    className="league-profile-edit-btn"
                    onClick={async () => {
                      await checkAuth();
                      navigate(`/dashboard/directory/manage/${league.id}`);
                    }}
                  >
                    Edit Listing
                  </button>
                )}

              </div>
            </div>
            {/* Bottom Pill Section of Top Container */}
            <div className="league-profile-pill-row">
              {sportLabel && (
                <button
                  type="button"
                  className={`league-profile-pill ${uniqueSports.length > 1 ? "is-clickable" : ""}`}
                  onClick={() => {
                    if (uniqueSports.length > 1) {
                      setPillModal({
                        title: "Sports",
                        content: sportFullList,
                      });
                    }
                  }}
                >
                  <div className="league-profile-pill-title">Sport</div>
                  <div className="league-profile-pill-value">{sportLabel}</div>
                </button>
              )}

              {audienceLabel && (
                <button
                  type="button"
                  className={`league-profile-pill ${uniqueAudiences.length > 1 ? "is-clickable" : ""}`}
                  onClick={() => {
                    if (uniqueAudiences.length > 1) {
                      setPillModal({
                        title: "Audiences",
                        content: audienceFullList,
                      });
                    }
                  }}
                >
                  <div className="league-profile-pill-title">Audience</div>
                  <div className="league-profile-pill-value">{audienceLabel}</div>
                </button>
              )}

              {programTypeLabel && (
                <button
                  type="button"
                  className={`league-profile-pill ${uniqueProgramTypes.length > 1 ? "is-clickable" : ""}`}
                  onClick={() => {
                    if (uniqueProgramTypes.length > 1) {
                      setPillModal({
                        title: "Program Types",
                        content: programTypeFullList,
                      });
                    }
                  }}
                >
                  <div className="league-profile-pill-title">Program Type</div>
                  <div className="league-profile-pill-value">{programTypeLabel}</div>
                </button>
              )}

              {styleLabel && (
                <button
                  type="button"
                  className={`league-profile-pill ${uniqueStyles.length > 1 ? "is-clickable" : ""}`}
                  onClick={() => {
                    if (uniqueStyles.length > 1) {
                      setPillModal({
                        title: "Styles",
                        content: styleFullList,
                      });
                    }
                  }}
                >
                  <div className="league-profile-pill-title">Level</div>
                  <div className="league-profile-pill-value">{styleLabel}</div>
                </button>
              )}

              {locationsLabel && (
                <button
                  type="button"
                  className={`league-profile-pill ${uniqueCities.length > 1 ? "is-clickable" : ""}`}
                  onClick={() => {
                    if (uniqueCities.length > 1) {
                      setPillModal({
                        title: "Cities",
                        content: citiesFullList,
                      });
                    }
                  }}
                >
                  <div className="league-profile-pill-title">Cities</div>
                  <div className="league-profile-pill-value">{locationsLabel}</div>
                </button>
              )}

              {/* <div className="league-profile-pill">
               <div className="league-profile-pill-title">Status</div>
               <div className="league-profile-pill-value">{listingStatus}</div>
             </div>
   */}
            </div>
          </div>
          {/* End of league-profile-top-card */}
          <div className="league-profile-public-tabs">
            <NavLink end to={`/leagues/${leagueNameAndId}`}>
              Overview
            </NavLink>

            {hasLeagueToolsAccess ? (
              <>
                <NavLink to={`/leagues/${leagueNameAndId}/schedule`}>Schedule</NavLink>
                <NavLink to={`/leagues/${leagueNameAndId}/standings`}>
                  Standings
                </NavLink>
                <NavLink to={`/leagues/${leagueNameAndId}/players`}>
                  Players
                </NavLink>
              </>
            ) : (
              <>
                <span className="league-profile-public-tab-locked">Schedule</span>
                <span className="league-profile-public-tab-locked">Standings</span>
                <span className="league-profile-public-tab-locked">Players</span>
              </>
            )}
          </div>
          {/* Left side of profile body */}
          <div className="league-profile-body">
            <div className="league-profile-main">

              {/* About Container */}
              <div className="league-profile-card">
                <h2 className="league-profile-card-title">About</h2>

                <p className="league-profile-about-text">
                  {description ? (
                    showFullAbout ? (
                      <>
                        {description}
                        <button
                          type="button"
                          className="league-profile-read-more-inline"
                          onClick={() => setShowFullAbout(false)}
                        >
                          Read less
                        </button>
                      </>
                    ) : (
                      <>
                        {truncateWords(description, 45)}
                        {description.trim().split(/\s+/).length > 45 && (
                          <>
                            ...{" "}
                            <button
                              type="button"
                              className="league-profile-read-more-inline"
                              onClick={() => setShowFullAbout(true)}
                            >
                              Read more
                            </button>
                          </>
                        )}
                      </>
                    )
                  ) : (
                    "No description yet."
                  )}
                </p>
              </div>
              {/* {scheduleUrl && (
                <div className="league-profile-live-data-strip">
                  <div>
                    <strong>Live League Data</strong>
                    <span>Schedule and standings powered by SportingHip</span>
                  </div>

                  <div className="league-profile-live-data-strip-actions">
                    <a
                      href={scheduleUrl}
                      target={league?.organization?.domain ? "_blank" : "_self"}
                      rel="noopener noreferrer"
                    >
                      Schedule
                    </a>

            
                  </div>
                </div>
              )} */}

              {/* Programs + Gallery Container */}
              <div className="league-profile-card">
                {/* Programs Section */}
                <div className="league-profile-section-block">
                  <div className="league-profile-card-header">
                    <div>
                      <h2 className="league-profile-card-title">Programs</h2>
                    </div>

                    {/* {groupedPrograms.length > 1 && (
                      <button
                        type="button"
                        className="league-profile-card-link-btn"
                        onClick={() => setShowAllPrograms((prev) => !prev)}
                      >
                        {showAllPrograms ? "View less" : "View all sports →"}
                      </button>
                    )} */}
                  </div>
                  <div className="league-profile-program-filter-row">
                    {sportFilterTabs.map((tab) => (
                      <button
                        key={tab}
                        type="button"
                        className={`league-profile-program-filter-pill ${activeSportFilter === tab ? "is-active" : ""
                          }`}
                        onClick={() => {
                          setActiveSportFilter(tab);
                          setActiveProgramFilter("all");
                          setShowAllPrograms(true);
                        }}
                      >
                        {tab === "all" ? "All Sports" : formatLabel(tab)}
                      </button>
                    ))}
                  </div>
                  <div className="league-profile-program-filter-row">
                    {programFilterTabs.map((tab) => (
                      <button
                        key={tab}
                        type="button"
                        className={`league-profile-program-filter-pill ${activeProgramFilter === tab ? "is-active" : ""}`}
                        onClick={() => {
                          setActiveProgramFilter(tab);
                          setShowAllPrograms(true);
                        }}
                      >
                        {tab === "all" ? "All" : getProgramTypeLabel(tab)}
                      </button>
                    ))}
                  </div>
                  <div className="league-profile-programs-layout">
                    <div
                      className={`league-profile-program-list ${groupedPrograms.length > 1 ? "has-sport-groups" : ""
                        }`}
                    >
                      {groupedPrograms.length > 0 ? (
                        visibleGroupedPrograms.map(([sport, sportPrograms]) => (
                          <div key={sport} className="league-profile-program-sport-group">
                            {groupedPrograms.length > 1 && (
                              <h3 className="league-profile-program-sport-title">{sport}</h3>
                            )}

                            <div className="league-profile-program-sport-items">
                              {sportPrograms.map((program) => {
                                const isSelected = selectedProgram?.id === program.id;
                                const programVenueNames = Array.isArray(program?.venues)
                                  ? program.venues.map((venue) => venue?.name).filter(Boolean)
                                  : [];

                                const venueNames =
                                  programVenueNames.length === 1
                                    ? programVenueNames[0]
                                    : programVenueNames.length > 1
                                      ? `${programVenueNames[0]} +${programVenueNames.length - 1}`
                                      : "";

                                return (
                                  <div key={program.id} className="league-profile-program-item-wrap">
                                    {!isSelected && (
                                      <button
                                        type="button"
                                        className="league-profile-program-item"
                                        onClick={() => setSelectedProgram(program)}
                                      >
                                        <div className="league-profile-program-item-top">
                                          <h4 className="league-profile-program-item-title">
                                            {getProgramTitle(program)}
                                          </h4>
                                        </div>

                                        <div className="league-profile-program-item-meta">
                                          {[
                                            getDivisionLabels(program).join(" / "),
                                            getProgramAgeLabel(program),
                                          ]
                                            .filter(Boolean)
                                            .join(" · ")}
                                        </div>

                                        {venueNames && (
                                          <div className="league-profile-program-item-location">
                                            <span>{venueNames}</span>
                                          </div>
                                        )}
                                      </button>
                                    )}

                                    {isSelected && (
                                      <>
                                        <div className="league-profile-program-item-desktop-selected">
                                          <button
                                            type="button"
                                            className="league-profile-program-item is-selected"
                                            onClick={() => setSelectedProgram(program)}
                                          >
                                            <div className="league-profile-program-item-top">
                                              <h4 className="league-profile-program-item-title">
                                                {getProgramTitle(program)}
                                              </h4>
                                            </div>

                                            <div className="league-profile-program-item-meta">
                                              {[
                                                getDivisionLabels(program).join(" / "),
                                                getProgramAgeLabel(program),
                                              ]
                                                .filter(Boolean)
                                                .join(" · ")}
                                            </div>

                                            {venueNames && (
                                              <div className="league-profile-program-item-location">
                                                <span>{venueNames}</span>
                                              </div>
                                            )}
                                          </button>
                                        </div>

                                        <div className="league-profile-program-detail-mobile-only">
                                          {renderProgramDetail(program, "league-profile-program-detail-card-mobile")}
                                        </div>
                                      </>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="league-profile-program-empty">
                          {activeProgramFilter === "all"
                            ? "No programs listed yet."
                            : `No ${formatLabel(activeProgramFilter)} programs found.`}
                        </div>
                      )}
                    </div>

                    <div className="league-profile-program-detail-desktop">
                      {renderProgramDetail(selectedProgram)}
                    </div>
                  </div>

                </div>

                {/* Gallery Section */}
                <div className="league-profile-section-block league-profile-section-block-gallery">
                  <div className="league-profile-card-header">
                    <h2 className="league-profile-card-title">Gallery</h2>
                    {Array.isArray(league.gallery_images) && league.gallery_images.length > 4 && (
                      <button className="league-profile-card-link-btn">View all</button>
                    )}
                  </div>

                  <div className="league-profile-gallery-grid">
                    {Array.isArray(league.gallery_images) && league.gallery_images.length > 0 ? (
                      league.gallery_images.slice(0, 4).map((img, index) => (
                        <div
                          className="league-profile-gallery-item"
                          key={index}
                          onClick={() => setSelectedGalleryImage(img)}
                        >
                          <img
                            src={img}
                            alt={`${name} gallery ${index + 1}`}
                            className="league-profile-gallery-image"
                          />
                        </div>
                      ))
                    ) : (
                      <div className="league-profile-gallery-empty">No gallery images yet.</div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Right side of profile body */}
            {/* Contact container */}
            <div className="league-profile-sidebar">

              {(hasContactInfo || hasSocialLinks) && (
                <div className="league-profile-card">
                  <h2 className="league-profile-card-title league-profile-card-title-spaced">
                    {hasContactInfo ? "Contact" : "Contact Us on Social Media"}
                  </h2>

                  {hasContactInfo ? (
                    <div className="league-profile-contact-list">
                      {contact_name && (
                        <div className="league-profile-contact-row">
                          <FaUser className="league-profile-program-venue-icon" />
                          <span className="league-profile-contact-label">Name:</span>
                          <span className="league-profile-contact-value">{contact_name}</span>
                        </div>
                      )}

                      {email && (
                        <div className="league-profile-contact-row">
                          <FaEnvelope className="league-profile-program-venue-icon" />
                          <span className="league-profile-contact-label">Email:</span>
                          <a href={`mailto:${email}`} className="league-profile-contact-value">
                            {email}
                          </a>
                        </div>
                      )}

                      {phone_number && (
                        <div className="league-profile-contact-row">
                          <FaPhoneAlt className="league-profile-program-venue-icon" />
                          <span className="league-profile-contact-label">Phone:</span>
                          <span className="league-profile-contact-value">{phone_number}</span>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="league-profile-social-row">
                      {instagram_url && (
                        <a
                          href={normalizeUrl(instagram_url)}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="league-profile-social-link"
                        >
                          <img src={Instagram} alt="Instagram" className="league-profile-social-icon social-icon-instagram" />
                        </a>
                      )}

                      {facebook_url && (
                        <a
                          href={normalizeUrl(facebook_url)}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="league-profile-social-link"
                        >
                          <img src={Facebook} alt="Facebook" className="league-profile-social-icon social-icon-facebook" />
                        </a>
                      )}

                      {twitter_url && (
                        <a
                          href={normalizeUrl(twitter_url)}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="league-profile-social-link"
                        >
                          <img src={Twitter} alt="Twitter" className="league-profile-social-icon social-icon-twitter" />
                        </a>
                      )}

                      {youtube_url && (
                        <a
                          href={normalizeUrl(youtube_url)}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="league-profile-social-link"
                        >
                          <img src={Youtube} alt="YouTube" className="league-profile-social-icon social-icon-youtube" />
                        </a>
                      )}
                    </div>
                  )}
                </div>
              )}

              {/* Location container */}
              <div className="league-profile-card">
                <h2 className="league-profile-card-title league-profile-locations-title">Locations</h2>
                {uniqueVenues.length > 0 && (
                  <select
                    className="league-profile-venue-select"
                    value={selectedVenueName}
                    onChange={(e) => setSelectedVenueName(e.target.value)}
                  >
                    {uniqueVenues.map((venue, index) => (
                      <option key={index} value={venue.name}>
                        {venue.name}
                      </option>
                    ))}
                  </select>
                )}
                <div className="league-profile-map-box">
                  {mapEmbedSrc ? (
                    <iframe
                      key={activeVenue?.name || "default-map"}
                      title="Venue map"
                      src={mapEmbedSrc}
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      loading="lazy"
                      allowFullScreen
                      referrerPolicy="no-referrer-when-downgrade"
                    />
                  ) : (
                    <div>No venue map yet.</div>
                  )}
                </div>
              </div>
              {/* Social Media Container */}
              {hasContactInfo && hasSocialLinks && (
                <div className="league-profile-card">
                  <h2 className="league-profile-card-title">Follow Us</h2>
                  <div className="league-profile-social-row">
                    {instagram_url && (
                      <a
                        href={normalizeUrl(instagram_url)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="league-profile-social-link"
                      >
                        <img src={Instagram} alt="Instagram" className="league-profile-social-icon social-icon-instagram" />
                      </a>
                    )}

                    {facebook_url && (
                      <a
                        href={normalizeUrl(facebook_url)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="league-profile-social-link"
                      >
                        <img src={Facebook} alt="Facebook" className="league-profile-social-icon social-icon-facebook" />
                      </a>
                    )}

                    {twitter_url && (
                      <a
                        href={normalizeUrl(twitter_url)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="league-profile-social-link"
                      >
                        <img src={Twitter} alt="Twitter" className="league-profile-social-icon social-icon-twitter" />
                      </a>
                    )}

                    {youtube_url && (
                      <a
                        href={normalizeUrl(youtube_url)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="league-profile-social-link"
                      >
                        <img src={Youtube} alt="YouTube" className="league-profile-social-icon social-icon-youtube" />
                      </a>
                    )}
                  </div>
                </div>
              )}
              {/* End right side of profile body */}
            </div>

          </div>
        </div>
        {selectedGalleryImage && (
          <div
            className="league-profile-gallery-modal"
            onClick={() => setSelectedGalleryImage(null)}
          >
            <div
              className="league-profile-gallery-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                type="button"
                className="league-profile-gallery-modal-close"
                onClick={() => setSelectedGalleryImage(null)}
              >
                ×
              </button>

              <img
                src={selectedGalleryImage}
                alt="Expanded gallery"
                className="league-profile-gallery-modal-image"
              />
            </div>
          </div>
        )}
        {pillModal && (
          <div
            className="league-profile-pill-modal"
            onClick={() => setPillModal(null)}
          >
            <div
              className="league-profile-pill-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                type="button"
                className="league-profile-pill-modal-close"
                onClick={() => setPillModal(null)}
              >
                ×
              </button>

              <h3 className="league-profile-pill-modal-title">{pillModal.title}</h3>
              <p className="league-profile-pill-modal-text">{pillModal.content}</p>
            </div>
          </div>
        )}


        {/* {selectedProgram && (
          <div
            className="league-profile-program-modal"
            onClick={() => setSelectedProgram(null)}
          >
            <div
              className="league-profile-program-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                type="button"
                className="league-profile-program-modal-close"
                onClick={() => setSelectedProgram(null)}
              >
                ×
              </button>
              <h3 className="league-profile-program-modal-title">
                {getProgramMetaLine(selectedProgram) || getProgramTitle(selectedProgram)}
              </h3>

              {getDivisionLabels(selectedProgram).length > 0 && (
                <div className="league-profile-program-modal-divisions">
                  Divisions: {getDivisionLabels(selectedProgram).join(" · ")}
                </div>
              )}

              {(Array.isArray(selectedProgram.venues) && selectedProgram.venues.filter((venue) => venue?.name).length > 0) || city || state ? (
                <div className="league-profile-program-modal-venues">
                  {Array.isArray(selectedProgram.venues) && selectedProgram.venues.filter((venue) => venue?.name).length > 0 ? (
                    selectedProgram.venues
                      .filter((venue) => venue?.name)
                      .map((venue, index) => (
                        <div key={index} className="league-profile-program-modal-venue-row">
                          <FaMapMarkerAlt className="league-profile-program-venue-icon" />
                          {venue.map_url ? (
                            <a
                              href={normalizeUrl(venue.map_url)}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="league-profile-program-venue-link"
                            >
                              {venue.name}
                            </a>
                          ) : (
                            <span>{venue.name}</span>
                          )}
                        </div>
                      ))
                  ) : (
                    <div className="league-profile-program-modal-venue-row">
                      <FaMapMarkerAlt className="league-profile-program-venue-icon" />
                      <span>{city && state ? `${city}, ${state}` : city || state}</span>
                    </div>
                  )}
                </div>
              ) : null}
              {(selectedProgram.contact_name || selectedProgram.email) && (
                <div className="league-profile-program-modal-contact">
                  {selectedProgram.contact_name && (
                    <div className="league-profile-program-modal-contact-row">
                      <FaUser className="league-profile-program-venue-icon" />
                      <span>{selectedProgram.contact_name}</span>
                    </div>
                  )}

                  {selectedProgram.email && (
                    <div className="league-profile-program-modal-contact-row">
                      <FaEnvelope className="league-profile-program-venue-icon" />
                      <a
                        href={`mailto:${selectedProgram.email}`}
                        className="league-profile-program-venue-link"
                      >
                        {selectedProgram.email}
                      </a>
                    </div>
                  )}
                </div>
              )}

              {selectedProgram.description && (
                <div className="league-profile-program-modal-description">
                  {selectedProgram.description
                    .split(/\n+/)
                    .filter(Boolean)
                    .map((paragraph, index) => (
                      <p key={index}>{paragraph.trim()}</p>
                    ))}
                </div>
              )}
            </div>
          </div>
        )} */}
        {(
          league.my_claim_status === "rejected" ||
          league.my_claim_status === "pending" ||
          (
            league.has_pending_claim &&
            league.my_claim_status !== "pending" &&
            !league.claimed_user_id
          ) ||
          (
            !league.claimed_user_id &&
            !league.has_pending_claim &&
            league.my_claim_status !== "rejected"
          )
        ) && (
            <div className="league-profile-claim-section">
              <div className="league-profile-claim-card">
                {league.my_claim_status === "rejected" && (
                  <div className="league-claim-rejected">
                    <div>❌ Your previous claim was rejected.</div>

                    {league.my_claim_admin_notes && (
                      <div className="league-claim-reason">
                        Reason: {league.my_claim_admin_notes}
                      </div>
                    )}

                    <button
                      className="league-retry-btn"
                      onClick={() => setShowClaimModal(true)}
                    >
                      Submit New Claim
                    </button>
                  </div>
                )}

                {league.my_claim_status === "pending" && (
                  <div className="league-claim-pending">
                    <div className="claim-status-icon">⏳</div>

                    <div className="claim-status-text">
                      <strong>Claim submitted</strong>
                      <div className="claim-status-sub">
                        Our team is reviewing your request. You'll be notified once it's approved.
                      </div>
                    </div>
                  </div>
                )}

                {league.has_pending_claim &&
                  league.my_claim_status !== "pending" &&
                  !league.claimed_user_id && (
                    <div className="league-claim-locked">
                      <div className="claim-status-icon">⏳</div>

                      <div className="claim-status-text">
                        <strong>Claim under review</strong>
                        <div className="claim-status-sub">
                          Another ownership request for this listing is currently being reviewed.
                        </div>
                      </div>
                    </div>
                  )}

                {!league.claimed_user_id &&
                  !league.has_pending_claim &&
                  league.my_claim_status !== "rejected" &&
                  publicUser && (
                    <div className="league-profile-cta">
                      <h4>Own this league?</h4>
                      <p>
                        Claim your page, add updates, and create a registration link.
                      </p>
                      <button onClick={() => setShowClaimModal(true)}>
                        Claim this listing
                      </button>
                    </div>
                  )}

                {!league.claimed_user_id &&
                  !league.has_pending_claim &&
                  league.my_claim_status !== "rejected" &&
                  !publicUser && (
                    <div className="league-profile-cta">
                      <h4>Own this league?</h4>
                      <p>Login to claim and manage this page, including adding a registration link.</p>
                      <button onClick={() => navigate("/login")}>
                        Login to Claim
                      </button>
                    </div>
                  )}
              </div>
            </div>
          )}

        {showClaimModal && (
          <ClaimLeagueModal
            directoryLeagueId={directoryLeagueId}
            onClose={() => setShowClaimModal(false)}
            onSuccess={fetchLeague}
          />
        )}

      </div>
      <DirectoryFooter variant="profile" />
    </>
  );
}

export default LeagueProfileV2
